// ArChat Incoming Message Sound State
// Created: 04-04-2026 12:10:00
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Estado interno del motor IMS (Incoming Message Sound).
 * Mantiene deduplicación por mensaje, pendientes por conversación
 * y control del loop de audio global.
 */

/**
 * @returns {Map<string, { conversationId: string, messageId: string, ts: number }>}
 */
function createPendingMap() {
  return new Map();
}

/**
 * @returns {Set<string>}
 */
function createSeenSet() {
  return new Set();
}

/**
 * @returns {import('./incomingMessageSoundRules').IncomingMessageSoundState}
 */
export function createIncomingMessageSoundState() {
  return {
    enabled: true,
    activeConversationId: '',
    pendingByConversation: createPendingMap(),
    processedMessageIds: createSeenSet(),
    currentLoopConversationId: '',
    loopTimerId: null,
    hasAutoplayBlock: false,
    lastUnlockAt: 0,
  };
}

/**
 * Evita crecimiento infinito del set de deduplicación.
 * @param {Set<string>} messageSet
 * @param {number} maxSize
 */
export function trimProcessedMessageIds(messageSet, maxSize = 1200) {
  if (!(messageSet instanceof Set) || messageSet.size <= maxSize) return;
  const keep = Math.floor(maxSize * 0.65);
  const all = Array.from(messageSet);
  const tail = all.slice(-keep);
  messageSet.clear();
  tail.forEach((id) => messageSet.add(id));
}

